import {createAction} from 'Shared/utilities/actionCreator'; // Assuming a utility function to create actions
import {Async, Empty} from 'Core/models/Async';
import {A360ProductModel} from 'Quoting/models/Quoting';
import {Map as ImmutableMap} from 'immutable';

export const getRatingDetails = (modelName: A360ProductModel, policyNumber: string, packageCd: string) =>
  createAction(RatingDetailsActionType.GET_RATING_DETAILS, {modelName, policyNumber, packageCd});

export const changeRatingDetails = (ratingDetails: Async<ImmutableMap<string, any>>) =>
  createAction(RatingDetailsActionType.CHANGE_RATING_DETAILS, {ratingDetails});

export const clearRatingReportDetails = () => createAction(RatingDetailsActionType.CLEAR_RATING_REPORT_DETAILS);

export const setSelectedPlan = (planOptions: {displayValue: string; code: string; orderNo: number}[]) => ({
  type: RatingDetailsActionType.SET_SELECTED_PLAN,
  payload: planOptions,
});

// actionTypes.ts
export enum RatingDetailsActionType {
  GET_RATING_DETAILS = 'ratingDetails/GET_RATING_DETAILS',
  CHANGE_RATING_DETAILS = 'ratingDetails/CHANGE_RATING_DETAILS',
  SET_SELECTED_PLAN = 'ratingDetails/SET_SELECTED_PLAN',
  CLEAR_RATING_REPORT_DETAILS = 'ratingDetails/CLEAR_RATING_REPORT_DETAILS',
}

type RatingDetailsState = {
  ratingDetails: Async<ImmutableMap<string, any>>;
  selectedPlan: {displayValue: string; code: string; orderNo: number}[];
};

const DEFAULT_RATING_DETAILS_STATE: RatingDetailsState = {
  ratingDetails: new Empty(),
  selectedPlan: [],
};

type RatingAction =
  | {
      type: RatingDetailsActionType.GET_RATING_DETAILS;
      payload: {modelName: A360ProductModel; policyNumber: string; packageCd: string};
    }
  | {type: RatingDetailsActionType.CHANGE_RATING_DETAILS; payload: {ratingDetails: Async<ImmutableMap<string, any>>}}
  | {type: RatingDetailsActionType.SET_SELECTED_PLAN; payload: {displayValue: string; code: string; orderNo: number}[]}
  | ReturnType<typeof clearRatingReportDetails>;

export default (state: RatingDetailsState = DEFAULT_RATING_DETAILS_STATE, action: RatingAction): RatingDetailsState => {
  switch (action.type) {
    case RatingDetailsActionType.GET_RATING_DETAILS:
      return {...state, ratingDetails: new Empty()};

    case RatingDetailsActionType.CHANGE_RATING_DETAILS:
      return {...state, ratingDetails: action.payload.ratingDetails};

    case RatingDetailsActionType.CLEAR_RATING_REPORT_DETAILS:
      return {...state, ratingDetails: new Empty()};

    default:
      return state;
  }
};
